let seq = 0;

// Monotonic client-side ids for append-only lists (chat turns), so React keys never shift.
export const nextMid = () => `m${Date.now().toString(36)}${(seq += 1).toString(36)}`;
